/**
 * allIds.js
 * Written by: Alex Kasemir
 */

import uniq from 'lodash.uniq';
import questionActions from '../../actions';

/**
 * Description of the allIds reducer
 */
const allIds = (state = [], action) => {
  switch (action.type) {
    case questionActions.GET_QUESTION_SUCCESS:
      return uniq([...state, action.id]);
    case questionActions.GET_QUESTIONS_SUCCESS:
      return uniq(state.concat(action.questions.map((question) => question.id)));
    default:
      return state;
  }
};

export default allIds;
